export default {
  title: 'Order & Pay On Your Phone',
  description: 'The fastest way to dine-in',
  buttons: {
    view_menu: 'View Menu & Order',
  },
};